angular.module("vgresiduos").controller("MasterUserEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/usuarios/${$stateParams.id}`);
		};
	}
]);
